import { ChatConversations } from '@prisma/client';
import { EmployeeToBusiness, Service } from '../../interfaces';
import { UserConversation } from '../../types/chats';

export function getEmployeesToAdd({
  conversationData,
  employees,
  services,
  currentUserId,
  currentBusinessId,
  participants,
}: {
  conversationData:
    | Pick<ChatConversations, 'businessId' | 'employeeId'>
    | undefined
    | null;
  employees: EmployeeToBusiness[] | undefined;
  services: Service[] | undefined;
  currentUserId: string;
  currentBusinessId: string;
  participants: UserConversation['participants'];
}): EmployeeToBusiness[] {
  const canAddEmployee =
    !!conversationData &&
    !!conversationData.businessId &&
    !conversationData.employeeId &&
    conversationData.businessId === currentBusinessId;
  if (!canAddEmployee) return [];
  const isServiceProvider = (employeeId: string) =>
    !!services?.some(service =>
      service.employeesToServices.some(
        employeeToService => employeeToService.employeeId === employeeId,
      ),
    );
  return (employees ?? []).filter(
    e =>
      e.employeeId !== currentUserId &&
      (e.isBookable || isServiceProvider(e.employeeId)) &&
      !participants.some(p => p.participantId === e.employeeId),
  );
}
